import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M480-560 320-400l56 56 64-64v168h80v-168l64 64 56-56-160-160Zm-280-80v440h560v-440H200Zm0 520q-33 0-56-23t-24-57v-499q0-14 5-27t13-24l50-61q11-14 28-21t34-8h460q18 0 35 8t27 21l50 61q9 11 14 24t4 27v499q0 33-23 57t-57 23H200Zm16-600h528l-34-40H250l-34 40Zm264 300Z"/>',
  f: '<path d="M480-560 320-400l56 56 64-64v168h80v-168l64 64 56-56-160-160ZM200-120q-33 0-56-23t-24-57v-499q0-14 5-27t13-24l50-61q11-14 28-21t34-8h460q18 0 35 8t27 21l50 61q9 11 14 24t4 27v499q0 33-23 57t-57 23H200Zm16-600h528l-34-40H250l-34 40Z"/>',
  rao: { fill: '#5f6368' },
  raf: { fill: '#5f6368' },
};

export default data;
